export const appConfig = {
    // "baseUrlDeceased":"http://sc-deceased.pouyantech.local",
    // "baseUrlGift":"http://sc-gift.pouyantech.local"
    "baseUrlDeceased":"https://deceased.pouyanbroker.ir",
    "baseUrlGift":"https://gift.pouyanbroker.ir"
}